import React, {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import Header from './components/Header';
import Get from './components/Get';
import BottomTabs from './BottomTabs';
import ssCompanyLogo from './images/ss-company-logo.svg';

const Profile = () => {
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Mimic navigation focus event
    document.title = 'Profile';
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, [location]);

  return (
    <>
      <div style={styles.container}>
        <Header title="Profile" />

        {/* Profile Top Section */}
        <div style={styles.topSection}>
          <div style={styles.avatarContainer}>
            <img
              src={ssCompanyLogo}
              alt="SS Company"
              style={{height: 160, width: 160, borderRadius: 80}}
            />
          </div>
          <h2 style={styles.userNameText}>{user ? user.name : 'Loading...'}</h2>
        </div>

        {/* Info Cards */}
        <div style={styles.infoContainer}>
          <div style={{...styles.card, ...styles.gradient}}>
            <div style={styles.label}>Referral Code</div>
            <div style={styles.txt}>{user ? user.referal_code : '--'}</div>
          </div>
          <div style={{...styles.card, ...styles.gradient}}>
            <div style={styles.label}>Mobile Number</div>
            <div style={styles.txt}>{user ? user.mobile : '--'}</div>
          </div>
        </div>
      </div>
      <BottomTabs />
    </>
  );
};

const styles = {
  container: {
    background: 'linear-gradient(to bottom, #ffffff, #ffffff)',
    padding: '0px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  topSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '40px',
  },
  avatarContainer: {
    height: '170px',
    width: '170px',
    borderRadius: '85px',
    border: '5px solid #ffffff',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ccc',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
  },
  userNameText: {
    fontSize: '22px',
    color: '#000',
    fontWeight: '700',
    marginTop: '16px',
  },
  infoContainer: {
    padding: '0 20px',
    marginTop: '40px',
  },
  card: {
    borderRadius: '14px',
    padding: '18px 20px',
    marginBottom: '16px',
  },
  gradient: {
    background: 'linear-gradient(90deg, #1b4ca7, #0aa7788e)',
  },
  label: {
    color: '#fff',
    fontSize: '14px',
    marginBottom: '6px',
    fontWeight: '600',
    opacity: 0.8,
  },
  txt: {
    border: '1px solid #fff',
    color: '#fff',
    padding: '10px 12px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    textAlign: 'center',
  },
};

export default Profile;
